import { render, staticRenderFns } from "./SalaryDialog.vue?vue&type=template&id=6c116020&"
import script from "./SalaryDialog.vue?vue&type=script&lang=js&"
export * from "./SalaryDialog.vue?vue&type=script&lang=js&"
import style0 from "./SalaryDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalaryDialog.vue"
export default component.exports